var React = require('react');

function ExternalLinkIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6.5 3.5a3 3 0 0 0-3 3v11a3 3 0 0 0 3 3h11a3 3 0 0 0 3-3v-3a1 1 0 1 0-2 0v3a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1h3a1 1 0 1 0 0-2h-3zm6.5 0a1 1 0 1 0 0 2h4.086l-6.793 6.793a1 1 0 1 0 1.414 1.414L18.5 6.914V11a1 1 0 1 0 2 0V3.5H13z","fill":"#fff"}));
}

ExternalLinkIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ExternalLinkIcon;

ExternalLinkIcon.default = ExternalLinkIcon;
